var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _a, _Report_reportMessage;
/**
 * Message reporting
 *
 * @author      Viktoria Wiebe
 * @author      Jan-Hendrik Willms <tleilax+studip@gmail.com>
 * @version     1.0
 * @since       Stud.IP 4.5
 * @license     GLP2 or any later version
 * @copyright   2019 Stud.IP Core Group
 */
import eventBus from "./event-bus";
class Report {
    // Info message
    static info(title, content) {
        __classPrivateFieldGet(_a, _a, "m", _Report_reportMessage).call(_a, 'info', title, content);
    }
    // Success message
    static success(title, content) {
        __classPrivateFieldGet(_a, _a, "m", _Report_reportMessage).call(_a, 'success', title, content);
    }
    // Warning message
    static warning(title, content) {
        __classPrivateFieldGet(_a, _a, "m", _Report_reportMessage).call(_a, 'warning', title, content);
    }
    // Error message
    static error(title, content) {
        __classPrivateFieldGet(_a, _a, "m", _Report_reportMessage).call(_a, 'error', title, content);
    }
}
_a = Report, _Report_reportMessage = function _Report_reportMessage(type, title, content) {
    eventBus.emit('push-system-notification', {
        type: type,
        message: title,
        details: content
    });
};
export default Report;
